import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit, model, output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizationService } from '../../../../modules/fwcore';
import { AdminService } from '../../services';

@Component({
  selector: 'app-impersonation-current',
  standalone: true,
  imports: [NgClass, ButtonsModule],
  templateUrl: './impersonation-current.component.html',
  styleUrl: './impersonation-current.component.scss'
})
export class ImpersonationCurrentComponent implements OnInit, OnDestroy {

  // ---------------- Hybrid old/new input ----------------

  public impersonating = model('');
  public impersonateChanged = output<string>();


  //----------------- Control handling   ------------------

  protected impersonatingEmail?: string | null;

  //----------------- State properties  ------------------

  protected destroy$ = new Subject();

  //----------------- Constructor  ------------------

  constructor(protected router: Router
    , protected adminService: AdminService
    , protected authService: AuthorizationService
    // Add application specific services to enroll into impersonation
  ) {

  }

  //----------------- ng  ---------------------------

  ngOnInit(): void {

    this.impersonatingEmail = this.authService.getImpersonatingEmail();
    this.impersonating.set(this.authService.impersonatingName ?? '');

    this.adminService.setImpersonatingEmail(this.impersonatingEmail);

    // Add application specific services impersonation notification
    // this.myAppService.setImpersonatingEmail(this.impersonatingEmail);

    // Subscribe to router events to detect navigation changes
    // so we can refresh the impersonation status when the user navigates
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.refreshImpersonating();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //----------------- Control processing   ------------------

  protected refreshImpersonating() {

    const currImpersonating = this.authService.getImpersonatingEmail();

    if (this.impersonatingEmail !== currImpersonating) {
      this.impersonatingEmail = currImpersonating;
      this.impersonating.set(this.authService.impersonatingName ?? '');

      this.adminService.setImpersonatingEmail(this.impersonatingEmail);

      // Add application specific services impersonation notification
      // this.myAppService.setImpersonatingEmail(this.impersonatingEmail);

      this.impersonateChanged.emit(this.impersonatingEmail ?? '');
    }

  }

  protected onStopImpersonating() {

    this.impersonatingEmail = null;
    this.impersonating.set('');

    this.authService.resetImpersonationEmail();
    this.adminService.resetImpersonationEmail();

    // Add application specific services reset impersonation notification
    // this.myAppService.resetImpersonationEmail();

    this.impersonateChanged.emit('');
    this.router.navigate(['./home']);
  }

}
